'use strict';

import {ngDepModel} from './ngdepmodel.js';

import {evlCriterionModel} from './evlcriterionmodel.js';

export class checklistsDataModel extends ngDepModel
{
	
	criteria = {};
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	beforeSetup(data){
		if(typeof(data.criteria) !== 'undefined'){
			for(let id in data.criteria){
				data.criteria[id] = new evlCriterionModel(data.criteria[id], this._services.$filter, this._services.jsDataService);
			}
		}
	}

	isQInstruction(id){
		let q = this.criteria[id];
		if(!q){
			return false;
		}
		if(!q.instruction || q.instruction === ''){
			return false;
		}
		return true;
	}

	getCriteriaValue(id){
		let q = this.criteria[id];
		if(!q){
			return null;
		}
		if(q.value === ''){
			return '';
		}
		let classif = this.s('jsDataService').get('cfgClassif');
		let classifName = 'yesnonot';
		if(classif && typeof(classif[classifName]) !== 'undefined'){
			let v = this.s('$filter')('filter')(classif[classifName], {id: q.value}, true);
			if(v.length > 0){
				return v[0].title;
			}
		}
		return '';
	}

	getValue(name){
		switch(name){
			case 'projectGrantAmountRequested':
			case 'projectGrantAmountProposed':
			case 'projectGrantAmountFinal':
				if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
					return this.s('$filter')('currency')(this[name]);
				}
				return null;
		}
		return super.getValue(name);
	}

	afterSetup(){

	}

	getCriteriaList(){
		let items = [];
		for(let id in this.criteria){
			items.push(this.criteria[id]);
		}
		return items;
	}
	
	getCriteriaListNoHidden(){
		let items = [];
		for(let id in this.criteria){
			if(!this.criteria[id].hidden){
				items.push(this.criteria[id]);
			}
		}
		return items;
	}	
	getCriteriaData(){
		let obj = Object.assign({}, angular.copy(this.criteria));
		for(let id in obj){
			if(obj[id] instanceof evlCriterionModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}


}
